exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".external-login-item[data-v-40b394de]{display:flex;align-items:center}.external-login-item div[data-v-40b394de]{display:flex;flex-direction:column}.external-login-item div span[data-v-40b394de]{margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-40b394de","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Content/src/views/Profile.vue
// module id = 824
// module chunks = 1